export default __webpack_public_path__ + "7ce97ed0e4bb56de0a2364528a6159e9.jpg";